import styled, { StyledComponent } from 'styled-components'

import { HeaderlessCollapsibleContentAreaCard } from '@espoon-voltti/react-components/layout'

export const CustomAreaCard: StyledComponent<
  typeof HeaderlessCollapsibleContentAreaCard,
  any
> = styled(HeaderlessCollapsibleContentAreaCard)`
  .content-area-card-content-header {
    display: flex;
    flex-direction: row;
  }
  .content-area-card-content-header-title-wrapper {
    flex: 1;
  }
  .trigger .button.trigger-button {
    color: white;
    background-color: #3373c9;
  }
`
